module.exports = __webpack_public_path__ + "img/table5.2ec5eb88.jpg";